module.exports = __webpack_public_path__ + "img/add_theme_desktop_3.279d2896.png";